module.exports = __webpack_public_path__ + "static/about-6b98d0ccad267a5c56c010eb5eef03f3.jpg";